/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class SegmentsAPI extends ApiClient {
  constructor() {
    super('escaleshop/segments', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { segment: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { segment: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getContacts(id, { page = 1, sort = 'name' } = {}) {
    return axios.get(`${this.url}/${id}/contacts?page=${page}&sort=${sort}`);
  }
}

export default new SegmentsAPI();
